export const dependenceLabels = {
	['dependence-header']: 'Desculpe, o módulo ainda não esta pronto.',
};
